import React from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import amplitude from 'amplitude-js';
import { toggleModal } from 'apps/auth/actions/appAction';
import { toggleChat } from 'apps/auth/actions/chatAction';
import { closeRequest, setCheque } from 'apps/auth/actions/historyAction';
import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';
import { getHelpMobileIdParams } from 'apps/auth/components/utils/AmplitudeUtils';
import { GET_HELP_CLICKED, REQUEST_DECLINED } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { AUTH_REQUEST_CANCEL_LINK } from 'apps/auth/constants/UrlConstants';
import { canDeclineBill } from 'apps/auth/helpers/historyUtils';
import { getLangCountryPrefix, resolveArguments } from 'apps/auth/helpers/utils';
import { useThemeDetector } from 'apps/auth/hooks/theme';

const RequestMorePopup = ({ popupRef = null, ...props }) => {
    const cheque = props.cheque;
    const { theme } = useThemeDetector();

    return (
        <>
            <SimplePopup text={resolveArguments(props.chequeBillNumber, cheque?.id)} popupRef={popupRef}>
                {canDeclineBill(cheque) && (
                    <PopupButton
                        iconName="cross"
                        text={cheque?.incoming ? props.chequeBillDecline : props.chequeBillCancel}
                        href={`${AUTH_REQUEST_CANCEL_LINK}?billId=${cheque?.id}`}
                        onClick={(event) => {
                            amplitude.getInstance().logEvent(REQUEST_DECLINED);
                            const declineRequest = async (e) => {
                                e.preventDefault();
                                popupRef.current.close();
                                await props.toggleModal(false);
                                await props.closeRequest(cheque?.id);
                                props.setCheque(null);
                            };
                            declineRequest(event);
                        }}
                    />
                )}
                {props.showSupportChat && (
                    <PopupButton
                        iconName="message-bubble"
                        text={props.morePopupChatTitle}
                        onClick={(e) => {
                            e.preventDefault();
                            popupRef.current?.close();
                            props.toggleChat(true);
                        }}
                    />
                )}
                <PopupButton
                    iconName="lifebuoy"
                    text={props.morePopupSupportTitle}
                    href={`${getLangCountryPrefix(props.lang, props.country)}${props.faqUrl}?mode=${theme}`}
                    onClick={() => amplitude.getInstance().logEvent(GET_HELP_CLICKED, getHelpMobileIdParams(props.faqUrl))}
                />
            </SimplePopup>
        </>
    );
};

RequestMorePopup.propTypes = {
    popupRef: PropTypes.shape({ current: PropTypes.object }),
};

const mapStateToProps = (state) => ({
    cheque: state?.history?.cheque?.cheque,
    morePopupSupportTitle: state.messages.pageMessages.morePopupSupportTitle,
    morePopupChatTitle: state.messages.pageMessages.morePopupChatTitle,
    chequeBillNumber: state.messages.pageMessages.chequeBillNumber,
    chequeBillDecline: state.messages.pageMessages.chequeBillDecline,
    chequeBillCancel: state.messages.pageMessages.chequeBillCancel,
    lang: state.language.lang,
    userCountry: state.extra?.userCountry,
    country: state.app.country,
});
export default connect(mapStateToProps, { toggleModal, closeRequest, setCheque, toggleChat })(RequestMorePopup);
